/* eslint-disable */
import { showUserDetails } from '../../../actions';
import { useDispatch } from 'react-redux';

const AuthorData = ({ content, preventDefault }) => {
  const dispatch = useDispatch();
  const creatorDetails = content?.creators_details
    ? content.creators_details[0]
    : {};

  return (
    <div className="author-data">
      {creatorDetails && (
        <>
          <p
            className="name"
            onClick={(e) => {
              if (preventDefault) {
                e.preventDefault();
              }
              dispatch(showUserDetails(creatorDetails.id));
            }}
          >
            {creatorDetails.fullname ?? ''}
          </p>
          <p className="abbreviation">{creatorDetails.kuerzel ?? ''}</p>
          <p className="location">{creatorDetails.standort ?? ''}</p>
          <a
            className="telephone-number"
            href={'tel:' + creatorDetails?.telefon}
          >
            {creatorDetails.telefon ?? ''}
          </a>
        </>
      )}
    </div>
  );
};

export default AuthorData;
